import { IChatContext } from './types'
import { initialChatState } from '../hooks/useChatState'

export const initialChatContext: IChatContext = {
  state: initialChatState,
  dispatch: () => {},
}
